"use client";
import { Stack, Icon, Box } from "@chakra-ui/react";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text } from "@/elements";
import { MdOutlineDoneAll } from "@onemind-services-llc/react-icons-ng/md";
import Img1 from "public/iaas/costEfficient.4c199bb4.svg";
import Img2 from "public/iaas/wordpress-service.2952b864.svg";
import Img3 from "public/iaas/containerizedHosting.0e1aa36b.svg";

type DescriptionProps = {
  points: { label: string; text: string }[];
};

const Content = (props: DescriptionProps) => {
  const { points } = props;
  const textVariant = useTextVariant();
  return (
    <Stack>
      {points.map((point, i) => (
        <Box color={"text.100"} key={i}>
          <Text variant={textVariant} as="span" fontWeight={600}>
            <Icon as={MdOutlineDoneAll} mt={2} mr={2} />
            {point.label} -{" "}
          </Text>
          <Text variant={textVariant} as="span">
            {point.text}
          </Text>
        </Box>
      ))}
    </Stack>
  );
};

export const SOLUTIONS_CONSTANTS = {
  title: "Onemind's Dedicated Server Solutions – How We Help You?",
  desc: "At Onemind, we provide enterprise-level dedicated hosting designed for businesses, developers, and enterprises requiring high performance, security, and full control.",
  list: [
    {
      image: Img1,
      title: "High-Performance Compute & Storage",
      content: (
        <Content
          points={[
            {
              text: "Up to 128 cores for maximum compute power.",
              label: "Intel Xeon & AMD EPYC Processors",
            },
            {
              text: "Ultra-fast memory and low-latency storage for AI/ML and transactional applications.",
              label: "Up to 3TB RAM & NVMe SSDs",
            },
            {
              text: "Low-latency connectivity for web hosting, gaming, and SaaS.",
              label: "100Gbps+ Network Speeds",
            },
          ]}
        />
      ),
    },
    {
      image: Img2,
      title: "Advanced Security & Compliance",
      content: (
        <Content
          points={[
            {
              text: "Prevent cyber threats with real-time monitoring and AI-driven security.",
              label: "DDoS Protection & Firewalls",
            },
            {
              text: "Secure hosting for regulated industries.",
              label: "SOC2, HIPAA, GDPR & PCI-DSS Compliance",
            },
            {
              text: "Protect sensitive data with enterprise-grade security policies.",
              label: "Multi-Factor Authentication & Role-Based Access Control",
            },
          ]}
        />
      ),
    },
    {
      image: Img3,
      title: "Fully Customizable & Scalable Servers",
      content: (
        <Content
          points={[
            {
              text: "Deploy Linux, Windows, VMware, Proxmox, or Kubernetes-ready configurations.",
              label: "Full Root Access & OS Flexibility",
            },
            {
              text: "Choose full control or expert management with 24/7 support.",
              label: "Managed & Self-Managed Options",
            },
            {
              text: "Expand resources without downtime to support growing demands.",
              label: "Seamless Hardware Upgrades",
            },
          ]}
        />
      ),
    },
  ],
};
